<template>
  <div class="card" style="border-radius: 5px; width: 600px; height: 90vh !important; overflow-y:auto;" data-test="hotel_details_modal">
    <div v-if="loading">
      <b-loading :is-full-page="false" :active="loading" :can-cancel="true"></b-loading>
    </div>
    <div v-else>
      <header class="modal-card-head" >
                        <p class="modal-card-title">Hotel Details</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
      <b-tabs position="is-centered" class="block" v-model="activeTab" style="margin-bottom: 0px; padding-bottom: 0px;">
            <b-tab-item label="Images" v-if="description.imagesAndDescriptions.hotel.images">
              <HotelDetailImages :images="description.imagesAndDescriptions.hotel.images" />
            </b-tab-item>
            <b-tab-item label="Map">
              <div >
                <GMap class="is-overlay" :lat="parseFloat(location.Latitude) / 100000" :long="parseFloat(location.Longitude) / 100000" width="600" height="500" :image="image"/>
              </div>
            </b-tab-item>
            <b-tab-item label="Amenities" v-if="description.amenities.length > 0">
              <div class="columns" style="overflow: auto;">
                <div class="column" style="padding-top: 0px; padding-left: 20px;">
                  <ul style="font-size: 15px;">
                    <li v-for="(item, index) in description.amenities.slice(0, description.amenities.length / 2)" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div class="column" style="padding-top: 0px;">
                  <ul style="font-size: 15px;">
                    <li v-for="(item, index) in description.amenities.slice(description.amenities.length / 2, description.amenities.length)" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </b-tab-item>
            <b-tab-item v-if="description.policy.checkInTime" label="Policy">
              <div>
                <b style="padding-right: 5px; padding-left: 10px;">Check In Time: </b> {{description.policy.checkInTime | formatTime}} <br /> <br />
                <b style="padding-right: 5px; padding-left: 10px;">Check Out Time: </b> {{description.policy.checkOutTime | formatTime}} <br /> <br />
                <b style="padding-right: 5px; padding-left: 10px;">StayRequirement: </b> {{description.policy.stayRequirement._}} <br /> <br />
                <b style="padding-right: 5px; padding-left: 10px;">Accepted Payments: </b> {{acceptedPayments}}
              </div>
            </b-tab-item>
        </b-tabs>
    </div>
  </div>
</template>

<script>
import HotelDetailImages from './HotelDetailImages.vue'
import GMap from '../../GMap/GMap.vue'
import bookingMixin from "@/mixins/bookingMixin";

    export default {
      name: 'HotelDetails',
      mixins: [bookingMixin],
      components: {
        GMap,
        HotelDetailImages
      },
    props: {
        hotelCode: String,
        location: Object,
        image: String
      },
    data: function () {
          return {
            loading: true,
            description: {},
            activeTab: 0,
            cardConversions: {

            }
        }
      },
      methods: {
        getData(){
          var raw = {"stateful":false,"sessionKey":null,"normalizeResponse":true,"hotelCodes":[this.hotelCode],"infoToReturn":["generalInfo","guestRooms","meetingRooms","restaurants","policies","referencePoints","attractions","recreations","loyaltyPrograms","awards","contactInformation","multimedia"]};
          this.$app.huddleLabsServerCall('amadeus/hotel/description', raw)
            .then(result => {
              // // console.log(result);
              this.description = result.data[0], this.description.amenities = this.description.amenities.slice(0, 30);
              this.loading = false;
            })
        }
    },
    mounted () {
      this.getData()
    },
    computed: {
      acceptedPayments(){
        var payment;
        var message = "";
        // console.log(this.description.policy)
        for ( payment = 0; payment < this.description.policy.acceptedPayments.length; payment++) {
          message += this.description.policy.acceptedPayments[payment] + ', '
        }
        return message.slice(0, -2)
      }

    }
  }
</script>

<style scoped>
</style>
